/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

import CheckboxDropdown from "./CheckboxDropdown.container";

export default CheckboxDropdown;
